import React from 'react';
import PropTypes from 'prop-types';
import MultipleTagsInput from '../common/inputs/multipleTagsInput';
import DateFilter from '../common/dateFilter';
import Autocomplete from '../common/autocomplete';
import DesviationTypeInput from '../common/inputs/desviationTypeInput';

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return dateValue;
};

const Header = (props) => {
  let personName = '';

  // gets the name of the worker if a filter has already been done
  if (props.filters.datos && props.filters.personId) {
    const personFind = props.filters.datos.persons.find(item => item.key === props.filters.personId);
    if (personFind) {
      personName = personFind.value;
    }
  }

  return !props.loadingFilter && !props.filters.loading ? (
    <div className="header">
      <MultipleTagsInput
        categories={props.filter}
        filteredTags={props.filters.tags}
        language={props.language.filter}
        handleSubmit={props.handleSubmit}
        filterClassName="tour-header-filter__categories"
        isMultiple={true}
      />
      <div className="box-form islabel box170">
        <div>
          <label htmlFor="date-start">{props.language.filter.from}</label>
        </div>
        <div>
          <DateFilter
            date={validateDate(props.filters.date.fechaStartFinal, props.date.response.maxDate)}
            dif={props.filters.date.fechaStartFinal ? 0 : -(props.defaultRangeInDay*24*60*60*1000)}
            id="date-start"
            handleSubmit={props.handleSubmit}
            containerClassName="tour-header-filter__dateStart"
          />
        </div>
      </div>
      <div className="box-form islabel box170">
        <div>
          <label htmlFor="date-end">{props.language.filter.to}</label>
        </div>
        <div>
          <DateFilter
            date={validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate)}
            dif={0}
            id="date-end"
            handleSubmit={props.handleSubmit}
            containerClassName="tour-header-filter__dateEnd"
          />
        </div>
      </div>
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.tasks_manager.filters.person}</label>
        </div>
        <div>
          <Autocomplete
            value={personName.length > 0 ? personName : props.language.all}
            save={props.language.all}
            id={`personId`}
            alias="value"
            select="key"
            idItem="key"
            filter={props.filters.datos ? props.filters.datos.persons : []}
            handleSubmit={props.handleSubmit}
            containerClassName="tour-header-filter__person"
          />
        </div>
      </div>
      <DesviationTypeInput
        filters={props.filters ? props.filters : []}
        language={props.language}
        handleSubmit={props.handleSubmit}
        filterClassName="tour-header-filter__desviationType"
      />
    </div>
  ): (
    <div className="header" />
  );
};

Header.propTypes = {
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/header.jsx